import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { Button } from '../../../helpers'

import { sendWhatsAppMessage } from '../../../services/api/whatsappMessage'
import { raiseToast } from '../../../services/redux/reducers/toast/toast'

const OtpVerification = (props) => {
    const { updatedPhoneNumber, setIsOtpVerificationDialogVisible, updateUserObj, updateUserProfileData } = props
    const dispatch = useDispatch()

    const [otpCode, setOtpCode] = useState('')
    const [otp, setOtp] = useState(['', '', '', ''])
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')
    const [seconds, setSeconds] = useState(30)
    const [isActiveResendOTP, setIsActiveResendOTP] = useState(false)

    const focusValue = [useRef(null), useRef(null), useRef(null), useRef(null)]

    useEffect(() => {
        if (updatedPhoneNumber) {
            const otp = Math.floor(1000 + Math.random() * 9000).toString()
            setOtpCode(otp)
            handleSendWhatsAppMessage(otp)
            startTimer()
        }
    }, [updatedPhoneNumber])

    const handleSendWhatsAppMessage = async (otp) => {
        let whatsappMessages = [{
            "campaignName": "userprofile otp verification",
            "destination": updatedPhoneNumber,
            "userName": "ProcMart",
            "templateParams": [
                otp,
            ],
            "source": "new-landing-page form",
            "paramsFallbackValue": {
                "FirstName": "user"
            },
            "buttons": [
                {
                    "type": "button",
                    "sub_type": "url",
                    "index": 0,
                    "parameters": [
                        {
                            "type": "text",
                            "text": otp
                        }
                    ]
                }
            ]
        }]

        const data = { messages: whatsappMessages }

        setIsPageLoading(true)
        const response = await sendWhatsAppMessage(data)
        setIsPageLoading(false)

        if (!response.failure) {
            dispatch(raiseToast({ severity: 'success', detail: "WhatsApp OTP has been sent successfully" }))
        } else {
            dispatch(raiseToast({ severity: 'error', detail: response.data.error }))
        }
    }

    const handleOtpInput = (index, value) => {
        const newOtp = [...otp]
        newOtp[index] = value.replace(/\D/g, '').slice(-1)
        setOtp(newOtp)
        if (value && index < 3) {
            focusValue[index + 1].current.focus()
        }
    }

    const handlekeyDown = (index, event) => {
        if (event.key === 'Backspace' && !otp[index] && index > 0) {
            focusValue[index - 1].current.focus()
        }
    }

    const handleVerifyOtp = (e) => {
        e.preventDefault()
        const enteredOtp = otp.join('')
        if (enteredOtp === otpCode) {
            setSuccessMessage('OTP verified successfully!')
            setTimeout(() => {
                setIsOtpVerificationDialogVisible(false)
                updateUserProfileData(updateUserObj, updateUserObj.updatedUserProfileDetails.userId)
            }, 1200)
        }
        else if (!enteredOtp) {
            dispatch(raiseToast({ severity: 'error', detail: 'Please enter OTP' }))
        }
        else {
            dispatch(raiseToast({ severity: 'error', detail: 'Invalid OTP. Please try again.' }))
        }
    }

    const handleResentOtp = () => {
        const newOtp = Math.floor(1000 + Math.random() * 9000).toString()
        setOtpCode(newOtp)
        setOtp(['', '', '', ''])
        handleSendWhatsAppMessage(newOtp)
        setIsActiveResendOTP(false)
        setSeconds(30)
        startTimer()
    }

    const startTimer = () => {
        const interval = setInterval(() => {
            setSeconds(prev => {
                if (prev <= 1) {
                    clearInterval(interval)
                    setIsActiveResendOTP(true)
                    return 0
                }
                return prev - 1
            })
        }, 1000)
    }

    return (
        <div className="flex flex-column sm:mt-3 lg:flex-column col-12 lg:col-12">
            <div className="login-box col-10">
                <form className="login-box-content" onSubmit={handleVerifyOtp}>
                    <div className="flex col-12 text-center">
                        <p className="flex flex-column text-sm align-item-center my-2">
                            An OTP has been sent to your whatsapp, please verify it below.
                        </p>
                    </div>

                    <div className="grid justify-content-center">
                        {otp.map((value, index) => (
                            <div className="flex flex-column mb-2 lg:col-2 col-2 lg:mb-0" style={{ width: "16%" }} key={index}>
                                <input
                                    className="otp-input"
                                    value={value}
                                    ref={focusValue[index]}
                                    onChange={(e) => handleOtpInput(index, e.target.value)}
                                    autoFocus={index === 0}
                                    onKeyDown={(e) => handlekeyDown(index, e)}
                                    disabled={isPageLoading}
                                />
                            </div>
                        ))}
                    </div>
                    {successMessage && (
                        <div style={{ color: 'green', textAlign:'center', fontSize: 16, marginBottom: 8, letterSpacing: 1 }}>
                            {successMessage}
                        </div>
                    )}

                    {
                        !successMessage &&
                        <>
                            <div className="col-12 text-center flex justify-content-center align-items-center">
                                <p className="text-sm text-center">Didn't receive OTP?</p>
                                {isActiveResendOTP ? (
                                    <a className="resend-otp-text ml-1" onClick={handleResentOtp} style={{ cursor: 'pointer' }}> Resend OTP </a>
                                ) : (
                                    <p className="resend-otp-timer ml-2">
                                        Resend OTP in <span className="seconds-timer font-bold">00:{seconds < 10 ? `0${seconds}` : seconds}</span>
                                    </p>
                                )}
                            </div>
                        </>
                    }

                    <div className="mt-1 col-12">
                        <Button label="VERIFY OTP" className="w-12 p-2 login-btn" type="submit" disabled={successMessage}/>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default OtpVerification
